import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const patentMembershipApi = generateNomenApi(`/patent/patent-membership`);

export const patentMembershipOptions = generateNomenOptions('patent-membership', patentMembershipApi);
